// Import Phoenix LiveView
import { Socket } from "phoenix";
import "phoenix_html";
import { LiveSocket } from "phoenix_live_view";

// Import Alpine.js
import "alpinejs";

// FontAwesome Pro
import "../vendor/fontawesome/js/fontawesome";
import "../vendor/fontawesome/js/solid";
import "../vendor/fontawesome/js/regular";
import "../vendor/fontawesome/js/duotone";
import "../vendor/fontawesome/js/brands";
import "../vendor/fontawesome/js/v4-shims";

// For Drag and Drop polyfill for touch devices
import { polyfill } from "mobile-drag-drop";
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";

// Import Handsontable spreadsheet plugin for Group Recruitment Bulk Import
import Handsontable from "handsontable";

// Import key-value custom column type
import handsontableKeyValue from "handsontable-key-value";

import YAML from "js-yaml";

import sqlFormatter from "sql-formatter";

import topbar from "../vendor/topbar";

import { getHooks } from "live_svelte";
import * as svelteComponents from "../svelte/**/*.svelte";

// Import Components
import * as Components from "./components";

// Import LiveView-related functions
import "./liveview/index";

// Import LiveView Hooks
import Hooks from "./liveview/hooks";

// Import LiveView Uploaders
import Uploaders from "./liveview/uploaders";

// Import view JS files

import "./views";

// Topbar (sitewide loading indicator) config
// Determine the Portal's Secondary Branding Color. If not found, use a default.
const secondaryColor = document.querySelector(
  'meta[name="branding-secondary-color"]',
) || {
  content: "#41b6e6",
};
topbar.config({
  barColors: { 0: secondaryColor.content },
  barThickness: 5,
  shadowColor: "rgba(0, 0, 0, .3)",
});
window.addEventListener("phx:page-loading-start", () => topbar.show(200));
window.addEventListener("phx:page-loading-stop", () => topbar.hide());

window.YAML = YAML;
window.sqlFormatter = sqlFormatter;
window.Handsontable = Handsontable;
handsontableKeyValue(Handsontable);

const svgSpinner =
  '<svg class="spinner" viewBox="0 0 50 50"><circle class="ring" cx="25" cy="25" r="20"></circle><circle class="ball" cx="25" cy="5" r="5"></circle></svg>';

// Button is-loading animation
if (document.querySelector(".button")) {
  document.querySelectorAll(".button:not(.has-no-spinner)").forEach((btn) => {
    // Don't add Spinner if it's already there
    if (!btn.querySelector("svg.spinner")) {
      btn.insertAdjacentHTML("beforeend", svgSpinner);
    }
  });
}

window.ace = Components.default.ace;
window.toast = Components.default.toast;
window.svelteComponents = svelteComponents;

// Initialize Phoenix LiveView
const csrfToken = document
  .querySelector("meta[name='csrf-token']")
  ?.getAttribute("content");

const liveSocket = new LiveSocket("/live", Socket, {
  dom: {
    onBeforeElUpdated(from, to) {
      // prettier-ignore

      if(from.__x){ window.Alpine.clone(from.__x, to); }
    },
  },
  hooks: Object.assign({}, getHooks(svelteComponents), Hooks),
  params: {
    _csrf_token: csrfToken,
    clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
  uploaders: Uploaders,
});

liveSocket.connect();
window.liveSocket = liveSocket;

const socket = new Socket("/socket", {
  params: { token: window.userToken },
});

const channel = socket.channel("organization", {});

socket.connect();
channel.join();

window.addEventListener("phx:exec_js", (event) => {
  const el = document.getElementById(event.detail.id);
  liveSocket.execJS(el, el.getAttribute(event.detail.cmd));
});

// Initialize Drag and Drop polyfill for touch devices
polyfill({
  // Allow scrolling while dragging
  dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,

  // Drag action delay
  holdToDrag: 250,
});

// Flash message alerts
window.addEventListener("DOMContentLoaded", () => {
  const flashMsg = document.querySelector(
    "[id^=flash-msg-]:not([phx-hook=flash])",
  );

  if (flashMsg) {
    window.toast({
      message: flashMsg.textContent,
      type: `is-${flashMsg.dataset.type}`,
    });
  }
});

// Format MM-DD-YYYY to YYYY-MM-DD
window.formatDateISO = (date) => {
  const pattern = /(\d{2})[/|-](\d{2})[/|-](\d{4})/;

  if (!date || !date.match(pattern)) return null;
  return date.replace(pattern, "$3-$1-$2");
};
